import type { ID } from "types";
import { useSimpleRequest } from "hooks";
import useUser from "features/auth/useUser";
import { HighRiskMerchant as HighRiskMerchantApi } from "features/ecommerce/api";
import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";

export const useDeleteShareholders = () => {
    const request = useSimpleRequest();

    const { user } = useUser();

    const getDeleteShareholderIds = (shareholders: Array<HighRiskMerchant.DirectorsAndShareholders.Shareholder>) => (
        shareholders.reduce((deleteIds, shareholder) => {
            if (!shareholder.pki) {
                return deleteIds;
            }

            return [
                ...deleteIds,
                shareholder.pki
            ];
        }, Array.from<ID>([]))
    );

    const deleteShareholder = (pki: ID) => (
        request(() => HighRiskMerchantApi.deleteOnboardingsHighRiskShareholderIdentities({
            userId: user.coreId,
            pki
        }))
    );

    const deleteShareholders = (shareholderIds: Array<HighRiskMerchantType.Shareholder['pki']>) => (
        Promise.allSettled(shareholderIds.map(deleteShareholder))
    );

    const handleDeleteShareholders = (shareholders: Array<HighRiskMerchant.DirectorsAndShareholders.Shareholder>) => (
        deleteShareholders(getDeleteShareholderIds(shareholders))
    );

    return {
        handleDeleteShareholders
    };
};

export default useDeleteShareholders;
